import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import H6 from '@base/H6/H6';
import P2 from '@base/P2/P2';
import CourseLanguage from '@icon/CourseLanguage';
import textHelper from '@utils/textHelper';
import { mediaQuery, Spacings } from '@styles/index';

const Flex = styled.div`
  display: flex;
  align-items: center;
  grid-column: span 6;
  margin-top: ${Spacings.SPACING_10B};
  @media (max-width: 47.95em) {
    margin-top: 24px;
    grid-column: span 10;
    padding-bottom: 24px;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  height: ${Spacings.SPACING_12B};
  width: ${Spacings.SPACING_12B};
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: var(--color-divider);
  ${mediaQuery.uptoMobile} {
    width: ${Spacings.SPACING_10B};
    height: ${Spacings.SPACING_10B};
  }
`;

const Info = styled.div`
  margin-left: ${Spacings.SPACING_4B};
  align-self: center;
`;

const renderLanguages = (voiceLanguages, contentSlideLanguages) => {
  let text = null;
  if (voiceLanguages && voiceLanguages.length) {
    text = `Spoken: ${textHelper.getCommaSeparatedUIDs(
      voiceLanguages,
      'name'
    )}`;
  }
  if (contentSlideLanguages && contentSlideLanguages.length) {
    text += ` • Written: ${textHelper.getCommaSeparatedUIDs(
      contentSlideLanguages,
      'name',
      ', '
    )}`;
  }
  return text;
};

const Languages = ({ voiceLanguages, contentSlideLanguages }) => {
  if (!voiceLanguages && !contentSlideLanguages) return null;
  if (
    voiceLanguages &&
    !voiceLanguages.length &&
    contentSlideLanguages &&
    !contentSlideLanguages.length
  )
    return null;
  return (
    <Flex>
      <IconWrapper>
        <CourseLanguage
          size={Spacings.SPACING_6B}
          color="var(--color-text-secondary)"
          viewBox="0 0 22 24"
        />
      </IconWrapper>
      <Info>
        <H6 color="var(--color-text-primary)">Language</H6>
        <P2 color="var(--color-text-secondary)">
          {renderLanguages(voiceLanguages, contentSlideLanguages)}
        </P2>
      </Info>
    </Flex>
  );
};

export default Languages;

Languages.propTypes = {
  voiceLanguages: PropTypes.arrayOf(PropTypes.any),
  contentSlideLanguages: PropTypes.arrayOf(PropTypes.any)
};

Languages.defaultProps = {
  voiceLanguages: [],
  contentSlideLanguages: []
};
